import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ArchwizardModule } from '@y3krulez/angular-archwizard';
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';


@NgModule({
  imports: [
    AngularSvgIconModule.forRoot(),
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      tapToDismiss: false,
      closeButton: true,
      positionClass: 'toast-top-center',
    }),
    ToastContainerDirective,
    UiSwitchModule.forRoot({
      size: 'medium',
    }),
    NgxIntlTelInputModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    NgbModule,
    InfiniteScrollModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxSpinnerModule,
    AngularSvgIconModule,
    ArchwizardModule,
    NgxIntlTelInputModule,
    ToastContainerDirective,
  ],
})
export class AccountPanelSharedLibsModule {}
